import React, { Fragment } from "react"
import { Row, RowHeader } from "../../DataTable.jsx";

const TCP_MODE = {
    "IP_DISABLED": "Off", 
    "IP_FIXED": "Static", 
    "IP_DHCP": "DHCP"
}

export const TCPModule = ({ module }) => {

    // const enabled = module.settings.enabled != "DISABLED";
    return <Fragment>
        <RowHeader label="Cloud" />
        <Row label="Address">{ module.settings.cloud.address }</Row>
        <Row label="Port">{ module.settings.cloud.port }</Row>

        <RowHeader label="Ethernet" />
        <Row label="ip"> {module.settings.ethernet.ip } </Row>
        <Row label="dns"> {module.settings.ethernet.dns } </Row>
        <Row label="mask"> {module.settings.ethernet.mask } </Row>
        <Row label="mode"> {TCP_MODE[module.settings.ethernet.mode] } </Row>
        <Row label="gateway"> {module.settings.ethernet.gateway } </Row>
        {/* <Row label="Enabled" noParagraph 
        > 
            <ToggleOption disabled={true} value={enabled} />
        </Row> */}
    </Fragment>
}